export default {
  title: 'พัสดุ',
  pending_tab: 'รอรับ',
  collected_tab: 'รับแล้ว',
  tracking_number: 'เลขติดตาม',
  carrier: 'บริษัทขนส่ง',
  received_at: 'วันที่รับเข้า',
  collected_at: 'วันที่รับ',
  no_pending: 'ไม่มีพัสดุรอรับ',
  no_collected: 'ไม่มีพัสดุที่รับแล้ว',
  description: 'รายละเอียด',
}
